import React from 'react';
import styled from 'styled-components/native';
import Colors from '../constants/Colors';
import { B } from './Typography';

const StyledTouchable = styled.TouchableOpacity<{
  color: string;
  size: 'normal' | 'small';
}>`
  background-color: ${p => p.color};
  height: ${p => (p.size === 'normal' ? 40 : 32)}px;
  border-radius: 50px;
  padding: ${p =>
    p.size === 'normal' ? '12px 32px 12px 32px' : '8px 16px 8px 16px'};
  align-items: center;
  justify-content: center;
`;

const StyledCategoryText = styled(B)`
  font-size: 14px;
  line-height: 16px;
  color: ${Colors.secondaryText};
`;

interface ChipProps {
  color: string;
  size?: 'normal' | 'small';
  onPress?: () => void;
  children: string;
}

const Chip: React.FC<ChipProps> = ({
  color,
  size = 'normal',
  onPress,
  children
}) => {
  return (
    <StyledTouchable
      size={size}
      color={color}
      disabled={!onPress}
      onPress={() => onPress?.()}
    >
      <StyledCategoryText>{children}</StyledCategoryText>
    </StyledTouchable>
  );
};

export default Chip;
